import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  IconButton,
  Button,
  TextField,
  MenuItem
} from "@mui/material";
import GridViewIcon from "@mui/icons-material/GridView";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import styles from '../styles/HeroBanner.module.css';

const dummyBanners = [
  {
    id: 1,
    banner_image: "https://main.d34z81njze67ob.amplifyapp.com/assets/image17-CMssKShq.png",
    alt: "Diya Banner",
    title: "Diwali Sale",
    subheading: "Biggest Festive Offers",
    cta: "Shop",
    collection: "Men's Wear",
    url: ""
  },
  {
    id: 2,
    banner_image: "https://main.d34z81njze67ob.amplifyapp.com/assets/image18.png",
    alt: "Alt Text for Banner 2",
    title: "New Arrivals",
    subheading: "New Collection",
    cta: "View",
    collection: "",
    url: ""
  },
  {
    id: 3,
    banner_image: "https://main.d34z81njze67ob.amplifyapp.com/assets/image19.png",
    alt: "Alt Text for Banner 3",
    title: "",
    subheading: "Best Sellers",
    cta: "Buy",
    collection: "",
    url: ""
  },
  {
    id: 4,
    banner_image: "https://main.d34z81njze67ob.amplifyapp.com/assets/image20.png",
    alt: "Alt Text for Banner 4",
    title: "Digital Prints",
    subheading: "",
    cta: "See",
    collection: "",
    url: ""
  },
];

const collectionOptions = [
  "Jar Candles",
  "Votive Candles",
  "Tea Light Candles",
  "Scented Candles",
  "Birthday Candles",
];

export default function HeroBanner() {
  const [banners, setBanners] = useState(dummyBanners);
  const [editIndex, setEditIndex] = useState(null);
  const [form, setForm] = useState({});
  const [imgPreview, setImgPreview] = useState("");

  const handleEdit = (idx) => {
    setEditIndex(idx);
    setForm({ ...banners[idx] });
    setImgPreview(banners[idx].banner_image);
  };

  const handleFormChange = (field, value) => {
    if (field === "banner_image") setImgPreview(value);
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setForm((prev) => ({ ...prev, banner_image: url }));
      setImgPreview(url);
    }
  };

  const handleSave = () => {
    if (
      form.title.length > 20 ||
      form.subheading.length > 40 ||
      form.cta.length > 10
    ) return;
    const updated = [...banners];
    updated[editIndex] = { ...form };
    setBanners(updated);
    setEditIndex(null);
  };

  return (
    <Accordion defaultExpanded={false}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        className={styles.heroBannerHeader}
      >
        <GridViewIcon style={{ fontSize: 28, color: '#757575', marginRight: 12 }} />
        <span style={{ fontWeight: 500, fontSize: '16', color: '#232323'}}>Hero Banner</span>
      </AccordionSummary>
      <AccordionDetails>
        <div className={styles.heroBannerMainBox}>
          {/* Banner Orientation Section - always in its own card/box */}
          <div className={styles.heroBannerOrientationWrapper}>
            <Typography variant="h7" className={styles.heroBannerTitle}>
              Banner orientation
            </Typography>
            <div className={styles.heroBannerRow}>
              {banners.map((banner, idx) => (
                <div key={banner.id} className={styles.heroBannerItem}>
                  <img
                    src={banner.banner_image}
                    alt={banner.alt}
                    className={styles.heroBannerImg}
                  />
                  <div className={styles.heroBannerItemActions}>
                    <IconButton size="small" onClick={() => handleEdit(idx)}>
                      <EditOutlinedIcon style={{ color: '#888' }} />
                    </IconButton>
                    <IconButton size="small">
                      <VisibilityOutlinedIcon style={{ color: '#888' }} />
                    </IconButton>
                    <IconButton size="small">
                      <DeleteOutlinedIcon style={{ color: 'red' }} />
                    </IconButton>
                  </div>
                </div>
              ))}
            </div>
            <Typography variant="body2" className={styles.heroBannerShuffleText}>
              Shuffle images to define 1-4 sequence
            </Typography>
          </div>

          {/* Edit Form Section - in its own card/box below orientation */}
          {editIndex !== null && (
            <div className={styles.heroBannerEditFormWrapper}>
              <div className={styles.heroBannerEditForm}>
                <Typography variant="subtitle1" style={{ marginBottom: 12, fontWeight: 600 }}>Name / Image Alt Text</Typography>
                <TextField
                  fullWidth
                  sx={{ mb: 3 }}
                  value={form.alt || ''}
                  onChange={e => handleFormChange('alt', e.target.value)}
                />
                <div className={styles.heroBannerEditImgRow}>
                  <div>
                    <img
                      src={imgPreview}
                      alt="Preview"
                      className={styles.heroBannerEditImgPreview}
                    />
                    <Typography variant="caption" color="text.secondary" className={styles.heroBannerEditImgLabel}>W 1440px / H 300px</Typography>
                  </div>
                  <IconButton component="label" className={styles.heroBannerEditUploadBtn}>
                    <FileUploadOutlinedIcon />
                    <input hidden accept="image/*" type="file" onChange={handleImageUpload} />
                  </IconButton>
                </div>
                <Typography variant="subtitle1" style={{ marginBottom: 4, fontWeight: 600 }}>Title</Typography>
                <TextField
                  fullWidth
                  sx={{ mb: 1 }}
                  value={form.title || ''}
                  inputProps={{ maxLength: 20 }}
                  helperText={"Max 20 characters including space"}
                  onChange={e => handleFormChange('title', e.target.value)}
                />
                <Typography variant="subtitle1" style={{ marginBottom: 4, fontWeight: 600 }}>Subheading</Typography>
                <TextField
                  fullWidth
                  sx={{ mb: 1 }}
                  value={form.subheading || ''}
                  inputProps={{ maxLength: 40 }}
                  helperText={"Max 40 characters including space"}
                  onChange={e => handleFormChange('subheading', e.target.value)}
                />
                <Typography variant="subtitle1" style={{ marginBottom: 4, fontWeight: 600 }}>CTA Text</Typography>
                <TextField
                  fullWidth
                  sx={{ mb: 1 }}
                  value={form.cta || ''}
                  inputProps={{ maxLength: 10 }}
                  helperText={"Max 10 characters including space"}
                  onChange={e => handleFormChange('cta', e.target.value)}
                />
                <Typography variant="subtitle1" style={{ marginBottom: 4, fontWeight: 600 }}>Link collection page</Typography>
                <TextField
                  select
                  fullWidth
                  sx={{ mb: 2 }}
                  value={form.collection || ''}
                  onChange={e => handleFormChange('collection', e.target.value)}
                >
                  {collectionOptions.map(opt => (
                    <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                  ))}
                </TextField>
                <Typography align="center" sx={{ my: 1 }}>OR</Typography>
                <TextField
                  label="URL to link collection page"
                  fullWidth
                  sx={{ mb: 2 }}
                  value={form.url || ''}
                  onChange={e => handleFormChange('url', e.target.value)}
                />
                <div className={styles.heroBannerEditFormActions}>
                  <Button 
                    variant="contained" 
                    style={{ background: 'rgba(227, 221, 221, 1)', color: '#000',  border: '1.5px solid #000', borderRadius: 8, fontWeight: 400, minWidth: 90 }}
                    onClick={handleSave} 
                    disabled={
                      (form.title && form.title.length > 20) ||
                      (form.subheading && form.subheading.length > 40) ||
                      (form.cta && form.cta.length > 10)
                    }
                  >Save</Button>
                  <Button 
                    variant="outlined" 
                    style={{ background: '#fff', color: '#000', border: '1.5px solid #000', borderRadius: 8, fontWeight: 400, minWidth: 100, marginLeft: 8 }}
                    onClick={() => setEditIndex(null)}
                  >Cancel</Button>
                </div>
              </div>
            </div>
          )}
        </div>
      </AccordionDetails>
    </Accordion>
  );
}